import {cardImages} from '../../assets/ImageIndex'

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

const titleA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '15px': isMobileMedium ? '17px': isMobileBig ? '18px': isMiniNotebook ? '20px' : '25px',
});

const brA = (isDesktopOrLaptop: boolean) => ({
  height: '8px',
});
const brB = (isDesktopOrLaptop: boolean) => ({
  height: '5px',
});
const brC = (isDesktopOrLaptop: boolean) => ({
  height: '3px',
});


const textA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  width: isMobileMini ? '310px': isMobileMedium ? '460px': isMobileBig ? '570px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const textB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const divA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': isMobileMini ? 'column': isMobileMedium ? 'column': isMobileBig ? 'column': isMiniNotebook ? 'row' : 'row', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const listA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
    color: '#333',
    fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
    gap: isMobileMini ? '8px': isMobileMedium ? '10px': isMobileBig ? '15px': isMiniNotebook ? '18px' : '18px',
    textAlign: 'justify',
    width: isMobileMini ? '290px': isMobileMedium ? '440px': isMobileBig ? '550px': isMiniNotebook ? '680x' : '880px',
})

const imageA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '290px': isMobileMedium ? '420px': isMobileBig ? '450px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '450px' : '500px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})

export const card_16_01_25 = {

  date: '16-01-2025',
  routeCard: '/exercicios/yoga/16-01-2025',
  description: 'Mais do que uma prática física, o yoga é uma filosofia de vida, aqui encontrará tudo sobre o yoga',
  month: 'Janeiro',
  shortTitle: 'Yoga: Bom para a Mente e o Corpo',
  elements: [
    {
      type: 'title',
      content: 'Yoga: Uma prática milenar.',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          Yoga é uma prática milenar originada na Índia há mais de 4.000 anos, profundamente enraizada na cultura e espiritualidade do país. 
          Surgindo inicialmente como uma prática espiritual e ao longo do tempo evolui tambem como práticas meditativas.
          A palavra "yoga" deriva do sânscrito "yuj", que significa "unir" ou "integrar", simbolizando a união entre corpo, mente e espírito.
           Os primeiros registros do yoga aparecem nos Vedas, escrituras sagradas da tradição hindu, e sua sistematização foi feita nos Yoga Sutras de Patanjali, 
           onde são descritos os princípios e práticas fundamentais. Inicialmente, o yoga era uma prática espiritual voltada para alcançar a iluminação, mas, 
           ao longo do tempo, evoluiu para incorporar aspectos físicos e mentais, tornando-se uma disciplina abrangente para o bem-estar.
          </p>
          <br></br>
          `,
          getStyles: textA,
        },
        {
          type: 'image',
          content: cardImages.yogaPicture_16_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divA,
    },
    {
      type: 'title',
      content: 'Prática do Yoga',
      getStyles: titleA,
    },
    {
      type: 'text',
      content: 
      `
      <p style="text-indent: 20px;">O yoga combina técnicas físicas, respiratórias e meditativas para promover saúde e equilíbrio. Suas práticas incluem:
      </p>
      `,
      getStyles: textB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'title',
          content: 'Vertentes do Yoga',
          getStyles: titleA,
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'text',
          content: 'Ao longo dos séculos, surgiram diversas vertentes do yoga, cada uma com ênfase em aspectos diferentes:',
          getStyles: textB,
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'list',
          content: [
            'Hatha Yoga: Focado em posturas físicas e exercícios de respiração, é a base da maioria das práticas modernas.',
           'Ashtanga Yoga: Uma prática dinâmica que segue uma sequência fixa de posturas, combinando movimento e respiração sincronizados.',
           'Kundalini Yoga: Centrado na ativação da energia espiritual que reside na base da coluna vertebral, combinando mantras, meditação e respiração.',
           'Iyengar Yoga: Ênfase no alinhamento correto do corpo, frequentemente utilizando acessórios como blocos e cintos.',
           'Raja Yoga: Conhecido como o "yoga real", concentra-se na meditação e no controle da mente.',
           'Bikram Yoga: Realizado em uma sala aquecida, com uma sequência fixa de 26 posturas e exercícios de respiração.',
          ],
          getStyles: listA,          
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'text',
          content: 'Essas vertentes oferecem diferentes abordagens e benefícios, permitindo que cada pessoa encontre a prática mais adequada ao seu estilo de vida.',
          getStyles: textB,
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'image',
          content: cardImages.YogaPos_16_01_25,
          getStyles: imageA,
        },
        {
          type: 'list',
          content: [
            'Asanas (Posturas Físicas): Conjunto de posições que fortalecem o corpo, aumentam a flexibilidade e melhoram o equilíbrio.',
           'Pranayama (Controle da Respiração): Exercícios respiratórios que ajudam a controlar a energia vital e reduzir o estresse.',
           'Meditação: Técnicas para acalmar a mente e promover a concentração e o autoconhecimento.',
           'Relaxamento: Prática de liberar tensões do corpo e da mente, permitindo um estado profundo de descanso.',
          ],
          getStyles: listA,          
        }
      ],
      getStyles: divA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `<br></br>
          <p style="text-indent: 20px;">Para começar a praticar o Yoga é fácil e rápido, é possível praticar em casa mesmo!
          Basta ter um espaço para os exercícios, um local bem iluminado, uma música calma e tapetes de yoga.
          </p>
          <br></br>
          `,
          getStyles: textB,
        },
        {
          type: 'image',
          content: cardImages.yogaExercise_16_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'br',
      content: '',
      getStyles: (isDesktopOrLaptop:boolean) => ({height: '8px'}),
    },
    {
      type: 'title',
      content: 'Benefícios de praticar yoga ',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'div',
      content: [
        {
          type: 'list',
          content: [
            'Ajuda no alívio das dores musculares;',
            'Corrige a postura e seu alinhamento;',
            'Ajuda no processo de emagrecimento;',
            'Reduz a ansiedade e as tendências depressivas;',
            'Melhora o quadro de ansiedade e tendências depressivas',
            'Promove a consciência Corporal'
          ],
          getStyles: listA,
        }
      ],
      getStyles: divA,
    },
    {
      type: 'text',
      content: 
      `<br></br>
      <p style="text-indent: 20px;">A yoga é uma ótima prática para reduzir a ansiedade, melhorar a respiração e diminuir as dores, os principais benefícios são:
      </p>
      <br></br>
      `,
      getStyles: textB,
    },
    {
      type: 'br',
      content: '',
      getStyles: (isDesktopOrLaptop:boolean) => ({height: '8px'}),
    },
        {
          type: 'div',
          content:[
            {
              type: 'title',
              content: 'Curso de Yoga com Fernanda Yoga',
              getStyles: titleA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brC,
            },
            {
              type: 'image',
              content: cardImages.yogaFernanda_16_01_25,
              getStyles: imageA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brC,
            },
            {
              type: 'text',
              content: 
              `
              <p style="text-indent: 20px;">
                Deseja praticar Yoga num curso iterativo e prático online? O curso de Yoga da Fernanda esta na promoção.
                clique no link para saber mais:
              </p>
              <br></br>
              `,
              getStyles: textB,
            },
          ],
          getStyles: divB,
        },
  ] as ElementType[],
  tags: ['exercícios', 'mente e corpo', 'yoga', 'ioga', 'oriente'],
  author: 'John Doe',
}

